export default __webpack_public_path__ + "static/media/title-homeIcon.8fccfe15.svg";